export enum ECirclePercentType {
  PERCENT = 1,
  TIME = 2,
  VALUE = 3
}
